<template>
  <v-container fluid>
    <v-row justify="center">
      <v-col xs="12">
        <v-card dense>
          <v-card-title>
            <div class="title mb-1">
              <span v-if="selectedCredito.productoDescripcion == 'Acuerdo'">
                Acuerdo de Pago Nº {{ selectedCredito.numero }} de
                <v-chip dark :color="selectedCredito.empresaColor">
                  {{ selectedCredito.empresa }}
                </v-chip>
              </span>
              <span v-else>
                Detalle Crédito Nº {{ selectedCredito.numero }}
              </span>
            </div>
            <v-spacer></v-spacer>
            <v-btn icon @click.stop="hideActiveSubTask"
              ><v-icon>close</v-icon></v-btn
            >
          </v-card-title>
          <v-card-text>
            <v-row dense>
              <v-list class="transparent" dense>
                <v-list-item>
                  <v-list-item-title>
                    Situacion:
                    <v-chip
                      label
                      :color="selectedCredito.statusMoraColor"
                      dark
                      small
                    >
                      {{ selectedCredito.statusMora }}
                    </v-chip>
                  </v-list-item-title>
                </v-list-item>

                <v-list-item>
                  <v-list-item-title
                    v-if="selectedCredito.primerVencimientoImpago"
                    >Próximo Vencimiento:
                    {{
                      selectedCredito.primerVencimientoImpago | formatDate
                    }}</v-list-item-title
                  >
                  <v-list-item-title v-else
                    >Próximo Vencimiento: (aún no vencido)</v-list-item-title
                  >
                </v-list-item>

                <v-list-item>
                  <v-list-item-title v-if="selectedCredito.fechaUltimoPago"
                    >Último Pago:
                    {{
                      selectedCredito.fechaUltimoPago | formatDate
                    }}</v-list-item-title
                  >
                  <v-list-item-title v-else
                    >Último Pago: No tiene</v-list-item-title
                  >
                </v-list-item>

                <v-list-item>
                  <v-list-item-title v-if="selectedCredito.cuotasVencidas > 0">
                    Deuda actual: {{ selectedCredito.cuotasVencidas }} ctas. por
                    un total de {{ selectedCredito.saldoVencido | currency }}
                  </v-list-item-title>
                  <v-list-item-title v-else
                    >Cuotas adeudadas a la fecha: (ninguna)</v-list-item-title
                  >
                </v-list-item>

                <v-list-item>
                  <v-list-item-title
                    v-if="
                      selectedCredito.cuotas -
                        selectedCredito.cuotasVencidas -
                        selectedCredito.cuotasPagas >
                      0
                    "
                    >Cuotas Por Vencer:
                    {{
                      selectedCredito.cuotas -
                      selectedCredito.cuotasVencidas -
                      selectedCredito.cuotasPagas
                    }}
                    por un total de
                    {{
                      (selectedCredito.saldoTotal -
                        selectedCredito.saldoVencido)
                        | currency
                    }}</v-list-item-title
                  >
                  <v-list-item-title v-else
                    >Cuotas Por Vencer: (ninguna)</v-list-item-title
                  >
                </v-list-item>

                <v-list-item>
                  <v-list-item-title
                    >Total Adeudado: {{ selectedCredito.saldoTotal | currency }}
                  </v-list-item-title>
                </v-list-item>

                <div
                  v-if="
                    selectedCredito.avisos && selectedCredito.avisos.length > 0
                  "
                >
                  <v-divider></v-divider>

                  <template v-for="aviso in selectedCredito.avisos">
                    <v-row :key="aviso.aviso" dense>
                      <v-col>
                        <v-tooltip bottom>
                          <template v-slot:activator="{ on }">
                            <div
                              v-on="on"
                              :class="'body-2 ' + aviso.color + '--text'"
                            >
                              <v-icon :color="aviso.color">{{
                                aviso.icon
                              }}</v-icon>
                              {{
                                aviso.aviso == 'Ofrecer Renovación'
                                  ? 'Estás en condiciones de Renovar!'
                                  : aviso.aviso
                              }}
                            </div>
                          </template>
                          <span>{{ aviso.masDatos }}</span>
                        </v-tooltip>
                      </v-col>
                    </v-row>
                  </template>
                  <v-divider></v-divider>
                </div>
              </v-list>
            </v-row>
            <v-row dense>
              <v-btn
                v-if="!showCuotasAdeudadas"
                color="success"
                @click="comenzarPago"
                small
              >
                Proceder con Selección de Cuotas a Pagar
              </v-btn>
            </v-row>

            <v-container v-if="showCuotasAdeudadas">
              <v-row dense>
                <v-alert :value="true" type="info">
                  Marque las cuotas que quiera abonar, solo pueden ser cuotas
                  consecutivas
                </v-alert>
              </v-row>

              <v-row dense align="center">
                <v-col cols="3"> Seleccionar Pago </v-col>
                <v-col>
                  <v-radio-group row v-model="tipoPagoCuota">
                    <v-radio value="total" label="Total" />
                    <v-radio value="cuota" label="Sólo Cuota" />
                    <v-radio value="punitorios" label="Sólo Puniorios" />
                    <v-radio value="excepcion" label="Parcial" />
                  </v-radio-group>
                </v-col>
              </v-row>

              <v-row dense align="center" v-if="tipoPagoCuota == 'excepcion'">
                <v-col cols="3">
                  <v-switch
                    label="Excepción"
                    v-model="solicitarExcepcion"
                    @click="
                      importeAplicarTotal = 0;
                      importeAplicarCuota = 0;
                      importeAplicarPunitorio = 0;
                      importeAplicarCargos = 0;
                    "
                  />
                </v-col>
                <v-col cols="3" v-if="!solicitarExcepcion">
                  <v-text-field
                    label="Importe a Aplicar"
                    v-model="importeAplicarTotal"
                  />
                </v-col>
                <v-col cols="3" v-if="solicitarExcepcion">
                  <v-text-field
                    label="Aplicar a Cuota"
                    v-model="importeAplicarCuota"
                  />
                </v-col>
                <v-col cols="3" v-if="solicitarExcepcion">
                  <v-text-field
                    label="Aplicar a Punit."
                    v-model="importeAplicarPunitorio"
                  />
                </v-col>
                <v-col cols="3" v-if="solicitarExcepcion">
                  <v-text-field
                    label="Aplicar a Cargo"
                    v-model="importeAplicarCargos"
                  />
                </v-col>
              </v-row>

              <v-row v-if="!$vuetify.breakpoint.smAndDown" dense>
                <v-data-table
                  :headers="headers"
                  dense
                  v-model="selectedCuotas"
                  :loading="loading"
                  :items="cuotaAPagar"
                >
                  <template slot="no-data">
                    <v-alert :value="true" icon="shopping_basket">
                      No tiene Cuotas Pendientes!
                    </v-alert>
                  </template>

                  <template
                    v-if="selectedCuotas.length > 0"
                    v-slot:body.append="{ headers }"
                  >
                    <tr>
                      <td
                        :colspan="headers.length"
                        class="text-xs-right body-2 light-green"
                      >
                        <b
                          >Total a Abonar:
                          {{
                            selectedCuotas.length > 0
                              ? selectedCuotas
                                  .map((i) => i.saldo)
                                  .reduce((a, b) => a + b, 0)
                              : 0 | currency
                          }}</b
                        >
                      </td>
                    </tr>
                  </template>

                  <template v-slot:item="{ item, isSelected, select }">
                    <tr :color="item.statusMoraColor">
                      <td class="text-xs-left caption">{{ item.concepto }}</td>
                      <td class="text-xs-left caption">
                        {{
                          item.fecha
                            | dateParse('YYYY-MM-DD')
                            | dateFormat('DD-MM-YYYY')
                        }}
                      </td>
                      <td class="text-xs-left caption">
                        {{ item.importe | currency }}
                      </td>
                      <td class="text-xs-left caption">
                        {{ item.cargosAtraso | currency }}
                      </td>
                      <td class="text-xs-left caption">
                        {{ item.saldo | currency }}
                      </td>
                      <td class="text-xs-left caption">{{ item.situacion }}</td>
                      <td v-if="tipoPagoCuota != 'excepcion'">
                        <v-simple-checkbox
                          class="caption"
                          color="green"
                          :value="isSelected"
                          @input="select($event)"
                          :disabled="!checkAbonarHabilitado(item)"
                        ></v-simple-checkbox>
                      </td>
                    </tr>
                  </template>
                </v-data-table>
              </v-row>

              <v-row v-else dense>
                <v-data-table
                  :headers="headersSmall"
                  dense
                  v-model="selectedCuotas"
                  :loading="loading"
                  :items="cuotaAPagar"
                >
                  <template slot="no-data">
                    <v-alert :value="true" icon="shopping_basket">
                      No tiene Cuotas Pendientes!
                    </v-alert>
                  </template>

                  <template
                    v-if="selectedCuotas.length > 0"
                    v-slot:body.append="{ headers }"
                  >
                    <tr>
                      <td
                        :colspan="headers.length"
                        class="text-xs-right body-2 light-green"
                      >
                        <b
                          >Total a Abonar:
                          {{
                            selectedCuotas.length > 0
                              ? selectedCuotas
                                  .map((i) => i.saldo)
                                  .reduce((a, b) => a + b, 0)
                              : 0 | currency
                          }}</b
                        >
                      </td>
                    </tr>
                  </template>

                  <template v-slot:item="{ item, isSelected, select }">
                    <tr :color="item.statusMoraColor">
                      <td>
                        <v-simple-checkbox
                          class="caption"
                          color="green"
                          :value="isSelected"
                          @input="select($event)"
                          :disabled="!checkAbonarHabilitado(item)"
                        ></v-simple-checkbox>
                      </td>
                      <td class="text-xs-left caption">
                        {{ item.concepto.replace('Cuota', '') }}
                      </td>
                      <td class="text-xs-left caption">
                        {{
                          item.fecha
                            | dateParse('YYYY-MM-DD')
                            | dateFormat('MM-YY')
                        }}
                      </td>
                      <td class="text-xs-left caption">
                        {{ item.saldo | currency }}
                      </td>
                      <!-- <td class="text-xs-left caption">{{ item.situacion }}</td> -->
                    </tr>
                  </template>
                </v-data-table>
              </v-row>

              <v-row>
                <v-col cols="6">
                  <v-btn
                    color="primary"
                    @click="procederConPago"
                    v-if="importeAPagar > 0"
                    small
                  >
                    Proceder con el Pago
                  </v-btn>
                </v-col>
              </v-row>
            </v-container>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>

    <v-row v-if="procederPago">
      <v-col>
        <v-card>
          <v-card-title>
            <div class="title mb-1">Confirmación de Pago</div>
            <v-spacer></v-spacer>
            <v-btn fab x-small color="success" @click="procederPago = false">
              <v-icon dark>close</v-icon>
            </v-btn>
          </v-card-title>
          <v-card-text>
            <v-row>
              <v-col cols="12">
                <v-alert color="success" dark dense>
                  <div v-if="!$vuetify.breakpoint.smAndDown">
                    <v-icon small>info</v-icon> Se está abonando un importe de:
                    {{ importeAPagar | currency }}
                  </div>
                  <div v-else>
                    <v-icon small>info</v-icon> Va a abonar:
                    {{ importeAPagar | currency }}
                  </div>
                  <div>
                    <v-icon small>info</v-icon> A aplicar al
                    {{ selectedCredito.productoDescripcion }} N°:
                    {{ selectedCredito.numero }}
                  </div>
                </v-alert>
              </v-col>
            </v-row>
            <v-row>
              <v-radio-group v-model="selectedMedioPago">
                <template v-slot:label>
                  <div><strong>Seleccione un Medio de Pago</strong></div>
                </template>
                <v-radio value="TARJETA">
                  <template v-slot:label>
                    <v-row align="center">
                      <strong class="success--text">
                        &nbsp; Tarjeta Débito&nbsp;&nbsp;</strong
                      >
                      <v-img
                        max-height="40"
                        max-width="60"
                        src="../../assets/icons/tarjetas/visa.png"
                      ></v-img>
                      <v-img
                        max-height="40"
                        max-width="60"
                        src="../../assets/icons/tarjetas/mastercard.png"
                      ></v-img>
                      <v-img
                        max-height="40"
                        max-width="60"
                        src="../../assets/icons/tarjetas/americanexpress.png"
                      ></v-img>
                      <v-img
                        max-height="60"
                        max-width="60"
                        src="../../assets/icons/tarjetas/Cabal.jpg"
                      ></v-img>
                      <v-img
                        max-height="40"
                        max-width="60"
                        src="../../assets/icons/tarjetas/maestro.png"
                      ></v-img>
                    </v-row>
                  </template>
                </v-radio>
                <!-- <v-radio value="MERCADOPAGO">
                                    <template v-slot:label>
                                        <v-row align="center">
                                            <strong class="info--text" color="#CD5C5C"> &nbsp; Mercado Pago (Tarjeta de Crédito)&nbsp;&nbsp;</strong>
                                            <v-img
                                                max-height="40"
                                                max-width="60"
                                                src="../../assets/icons/mercadopago.png"
                                            ></v-img>
                                        </v-row>
                                    </template>
                                </v-radio> -->
              </v-radio-group>
            </v-row>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="primary" @click="confirmarPago()">
              <v-icon right dark>navigate_next</v-icon> Proceder
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-col>
    </v-row>

    <v-dialog v-model="showPagoPorTarjeta" width="800">
      <app-pagoonline-tarjeta
        :selectedCredito="selectedCredito"
        :cuotasAPagar="cuotasAPagar"
        :personaId="personaId"
        :tipoPagoCuota="tipoPagoCuota"
        :solicitarExcepcion="solicitarExcepcion"
        :importeAplicarTotal="importeAplicarTotal"
        :importeAplicarCuota="importeAplicarCuota"
        :importeAplicarPunitorio="importeAplicarPunitorio"
        :importeAplicarCargos="importeAplicarCargos"
        v-on:update:visivility="showPagoPorTarjeta = $event"
        :visible="showPagoPorTarjeta"
        v-on:update:pagoOk="pagoConfirmado($event)"
      ></app-pagoonline-tarjeta>
    </v-dialog>
  </v-container>
</template>

<script>
import Vue from 'vue';
import { http } from '@/axios';
import { mapGetters, mapMutations } from 'vuex';

import { format } from 'date-fns';

export default {
  data: () => ({
    loading: false,
    showCuotasAdeudadas: false,
    procederPago: false,
    headers: [
      // definición de columnas
      { text: 'Cuota', value: 'cuota', sortable: false },
      { text: 'Vencimiento', value: 'vencimiento', sortable: false },
      { text: 'Importe', value: 'importe', sortable: false },
      { text: 'Cargos Atraso', value: 'cargosAtraso', sortable: false },
      { text: 'A Pagar', value: 'totalAPagar', sortable: false },
      { text: 'Situacion', value: 'situacion', sortable: false },
      { text: 'Abonar', value: 'accion', width: 40, sortable: false },
    ],
    headersSmall: [
      // definición de columnas (small devices)
      //{ text: '', value: 'accion', width:40, sortable:false },
      { text: 'Abonar', value: 'accion', width: 40, sortable: false },
      { text: 'Cuota', value: 'cuota', sortable: false },
      { text: 'Vto.', value: 'vencimiento', sortable: false },
      { text: 'A Pagar', value: 'totalAPagar', sortable: false },
      // { text: 'Situacion', value: 'situacion',sortable:false },
    ],
    cuotasPendientes: [],
    selectedCuotas: [],
    cuotasAPagar: [],
    selectedMedioPago: {},
    mostrarPagoPor: '',
    parametrosPago: {},
    showPagoPorTarjeta: false,
    tipoPagoCuota: 'total',
    solicitarExcepcion: false,
    importeAplicarTotal: 0,
    importeAplicarCuota: 0,
    importeAplicarPunitorio: 0,
    importeAplicarCargos: 0,
  }),
  props: {
    selectedCredito: {
      type: Object,
      required: false,
      default: null,
    },
    personaId: {
      type: String,
      required: false,
      default: null,
    },
  },
  watch: {
    tipoPagoCuota: function () {
      this.selectedCuotas = [];
    },
  },
  computed: {
    ...mapGetters(['user', 'DebugModeOn']),
    primerCuotaImpagaSinElegir: function () {
      //si no hay ninguna elegida devuelvo la primera pendiente
      if (!this.selectedCuotas || this.selectedCuotas.length === 0) {
        return this.cuotaAPagar[0];
      }
      //caso contrario devuelvo la primera con valor mayor a la maxima cuota elegida
      else {
        var maxCuotaElegida = Math.max(
          ...this.selectedCuotas.map((x) => x.cuota)
        );

        //si no hay cuotas sin elegir devuelvo una inexistente con el valor de la ultima cuota + 1 para que funcione la habilitación
        if (
          maxCuotaElegida == Math.max(...this.cuotaAPagar.map((x) => x.cuota))
        )
          return { cuota: maxCuotaElegida + 1 };

        return this.cuotaAPagar.find((cp) => cp.cuota > maxCuotaElegida);
      }
    },
    importeAPagar() {
      if (this.tipoPagoCuota == 'excepcion') {
        if (this.solicitarExcepcion)
          return (
            this.importeAplicarCuota +
            this.importeAplicarPunitorio +
            this.importeAplicarCargos
          );
        else return this.importeAplicarTotal;
      } else {
        if (this.selectedCuotas.length == 0) return 0;

        return this.selectedCuotas
          .map((i) => i.saldo)
          .reduce((a, b) => a + b, 0);
      }
    },
    cuotaAPagar() {
      if (this.tipoPagoCuota == 'cuota') {
        var nuevaLista = [];
        for (
          let i = 0;
          i <
          this.cuotasPendientes.filter(
            (x) => x.importe > 0 && x.situacion != 'Cancelada'
          ).length;
          i++
        ) {
          const element = Object.assign(
            {},
            this.cuotasPendientes.filter(
              (x) => x.importe > 0 && x.situacion != 'Cancelada'
            )[i]
          );
          element.saldo = element.saldo - element.cargosAtraso;
          nuevaLista.push(element);
        }
        return nuevaLista;
      } else if (this.tipoPagoCuota == 'punitorios') {
        var nuevaLista = [];
        for (
          let i = 0;
          i < this.cuotasPendientes.filter((x) => x.cargosAtraso > 0).length;
          i++
        ) {
          const element = Object.assign(
            {},
            this.cuotasPendientes.filter((x) => x.cargosAtraso > 0)[i]
          );
          element.saldo = element.cargosAtraso;
          nuevaLista.push(element);
        }
        return nuevaLista;
      }

      return this.cuotasPendientes;
    },
  },
  created() {
    Vue.$log.debug('SELECTED CREDITO');
    Vue.$log.debug(this.selectedCredito);
  },
  filters: {
    formatDate: function (value) {
      if (value) return format(value, 'DD-MM-YYYY');
    },
  },
  methods: {
    ...mapMutations([
      'alertError',
      'alertSuccess',
      'setCuotasAPagar',
      'hideActiveSubTask',
    ]),
    checkAbonarHabilitado(cuota) {
      if (this.tipoPagoCuota == 'punitorios') return true;

      // //solo permito marcar la primer cuota impaga sin elegir y la anterior a esa (para poder desmarcar)
      let cuotaAnteriorIndex = this.cuotaAPagar.findIndex(
        (x) => x.cuota == this.primerCuotaImpagaSinElegir.cuota
      );
      let cuotaAnterior = 0;
      if (cuotaAnteriorIndex > 0)
        cuotaAnterior = this.cuotaAPagar[cuotaAnteriorIndex - 1].cuota;

      if (
        !(cuota == this.primerCuotaImpagaSinElegir) &&
        !(cuota.cuota == cuotaAnterior)
      ) {
        return false;
      }

      //permito marcar cuotas atrasadas o del mes
      if (cuota.situacion.includes('Atrasada')) {
        return true;
      }

      var mesVencimientoCuota = new Date(cuota.fecha).getMonth();

      var mesActual = new Date().getMonth();

      if (mesVencimientoCuota == mesActual) {
        return true;
      }

      return true;
    },
    async comenzarPago() {
      this.showCuotasAdeudadas = true;
      await this.loadCuotasAdeudadas();
    },
    procederConPago() {
      if (this.importeAPagar <= 0) {
        this.alertError(
          'Atención! Debe elegir alguna cuota para pagar o ingresar un importe.'
        );
        return;
      }
      this.cuotasAPagar = this.selectedCuotas;

      this.procederPago = true;
    },
    async loadCuotasAdeudadas() {
      this.loading = true;
      try {
        const path =
          this.selectedCredito.productoDescripcion == 'Acuerdo'
            ? 'acuerdos/listcuentacorriente?acuerdoId='
            : 'creditos/listcuentacorriente?noFuturas=false&creditoId=';

        var result = await http.get(path + this.selectedCredito.creditoId);
        // console.log(result.list)
        this.cuotasPendientes = result.list.filter(
          (c) => c.tipo === 'CUOTA' && c.saldo > 0
        );

        //agrego un atributo numero de cuota para procesar mas fácil
        //lo saco de substring(9) porque en concepto viene "Cuota N° X"
        this.cuotasPendientes.forEach(function (item) {
          item.cuota = parseInt(item.concepto.substring(9));
        });
      } catch (error) {
        // Error
        this.alertError(error);
      }
      this.loading = false;
    },
    confirmarPago() {
      if (!this.selectedMedioPago) {
        this.alertError('Debe elegir un Medio de Pago.');
        return;
      }

      this.parametrosPago = {
        creditoId: this.selectedCredito.creditoId,
        cuotasAPagar: this.cuotasAPagar,
        selectedMedioPago: this.selectedMedioPago,
        tipoPagoCuota: this.tipoPagoCuota,
      };

      switch (this.selectedMedioPago) {
        case 'TARJETA':
          this.showPagoPorTarjeta = true;
          break;
        case 'MERCADOPAGO':
          this.mostrarPagoPor = 'mercado-pago';
          break;
        case 'PAGOFACIL':
          this.mostrarPagoPor = 'pago-efectivo';
          break;
        case 'RAPIPAGO':
          this.mostrarPagoPor = 'pago-efectivo';
          break;
        case 'TRANSFERENCIA':
          this.mostrarPagoPor = 'pago-transferencia';
          break;
      }
    },
    pagoConfirmado(value) {
      console.log('pagoConfirmado: ' + value);
      if (value) {
        this.alertSuccess('Se ha aplicado el pago correctamente..');
        this.hideActiveSubTask();
      }
    },
  },
};
</script>
